import { Component, OnInit, ViewChild } from "@angular/core";
import { MemberappBaseComponent } from "../memberapp-base/memberapp-base.component";
import { FormGroup, Validators } from "@angular/forms";
import {
	Addresses,
	CustomerAddress
} from "../../../shared/models/my-account-data.models";
import { AddressComponent } from "../_common";
import { MatRadioChange } from "@angular/material/radio";
import { getPrimaryAddress, CheckIfInternational } from "../../helpers/mapper";

@Component({
	selector: "app-change-address",
	templateUrl: "./change-address.component.html",
	styleUrls: ["./change-address.component.scss"]
})
export class ChangeAddressComponent extends MemberappBaseComponent {
	addressesForm: FormGroup;
	addresses: Addresses;

	get home() {
		return this.addressesForm.get("home");
	}
	// get hospital() {
	// 	return this.addressesForm.get("hospital");
	// }
	get business() {
		return this.addressesForm.get("business");
	}

	get homeAddress() {
		return this.home.get("address");
	}
	// get hospitalAddress() {
	// 	return this.hospital.get("address");
	// }
	get businessAddress() {
		return this.business.get("address");
	}

	@ViewChild("homeAddressComp", { static: false }) homeAddressComp: AddressComponent;
	// @ViewChild("hospAddressComp", { static: false }) hospAddressComp: AddressComponent;
	@ViewChild("busAddressComp", { static: false }) busAddressComp: AddressComponent;

	ngOnInit() {
		//this.loggerService.logInfo(this.memberAppDataService.memberAppData);

		//reset
		this.resetForm();

		//subscriptions
	}

	ngAfterViewInit(): void {

		let primaryAddress: CustomerAddress = getPrimaryAddress(this.addresses);
		if (primaryAddress) {
			this._setPrimary(primaryAddress.addresstype);
		}
	}

	resetForm() {
		this.addresses = this.memberAppDataService.memberAppData.addresses; //this.memberAppDataService.memberAppData.addresses;

		this.addressesForm = this.fb.group({
			home: this._getAddressFormGroup(this.addresses.home),

			// hospital: this._getAddressFormGroup(this.addresses.hospital),

			business: this._getAddressFormGroup(this.addresses.business)
		});

		let primaryAddress: CustomerAddress = getPrimaryAddress(this.addresses);
		if (primaryAddress) {
			this._setPrimary(primaryAddress.addresstype);
		}


	}

	private _getAddressFormGroup(ca: CustomerAddress): FormGroup {
		return this.fb.group({
			addressid: ca.addressid,
			addresstype: [ca.addresstype, Validators.required],
			isprimary: ca.isprimary,
			address: AddressComponent.buildForm(ca.address, this.fb)
		});
	}

	//Set Primary and Update Validations
	_setPrimary(addressType?: any) {
		this.home.get("isprimary").setValue(false);
		//this.hospital.get("isprimary").setValue(false);
		this.business.get("isprimary").setValue(false);

		if (!!!this.homeAddressComp) return;

		this.homeAddressComp.VALIDATE = false;
		//this.hospAddressComp.VALIDATE = false;
		this.busAddressComp.VALIDATE = false;

		// if (addressType == "Hospital") {
		// 	this.hospital.get("isprimary").setValue(true);
		// 	this.hospAddressComp.VALIDATE = true;
		// } else 
		if (addressType == "Business") {
			this.business.get("isprimary").setValue(true);
			this.busAddressComp.VALIDATE = true;
		} else {
			this.home.get("isprimary").setValue(true);
			this.homeAddressComp.VALIDATE = true;
		}

		this.homeAddressComp.updateValidations(this.homeAddress);
		// this.hospAddressComp.updateValidations(this.hospitalAddress);
		this.busAddressComp.updateValidations(this.businessAddress);
	}

	changePrimary(event: MatRadioChange) {
		this.addressesForm.markAsDirty();
		this._setPrimary(event.value);
	}

	save() {
		super.onSave(this.addressesForm);

		if (this.addressesForm.valid) {
			if (this.addressesForm.dirty) {
				// Copy the form values over the product object values
				this.addresses = this.changeAddressService.prepareDataModel(
					this.addresses,
					this.addressesForm
				);
				this.loggerService.logInfo(this.addresses);
				this.changeAddressService
					.saveAddresses(this.addresses)
					.subscribe(
						d => {
							this.onSaveComplete(d);
						},
						(error: any) => {
							this.errorMessage = <any>error;
							super.onError();
						}
					);
			} else {
				this.onSaveComplete();
			}
		}
	}

	onSaveComplete(d?: Addresses) {
		if (d) {
			this.addresses = d;
		}
		this.memberAppDataService.memberAppData.addresses = this.addresses;
		this.memberAppDataService.memberAppData.personalInfo.customerAddress = getPrimaryAddress(
			this.addresses
		);
		this.memberAppDataService.SetInternational();
		//pga:coding-5865 update flag value on address changes
		this.memberAppDataService.SetUSOrCanada();
		this.memberAppDomService.updateNavSummaryText(
			this.memberAppDataService.memberAppData
		);
		this.globalDomOpsService.notify("Addresses Information Updated");
		this.memberAppDataService.navigateToRoute("chapters");
	}

	cancel() {
		this.resetForm();
		this.memberAppDataService.navigateToRoute("chapters");
	}
}
